const enums = {
	supportedLanguages: [
		{
			value: 'hu',
			label: 'globals.languages.hu.label',
			shortLabel: 'globals.languages.hu.shortLabel',
		},
		{
			value: 'en',
			label: 'globals.languages.en.label',
			shortLabel: 'globals.languages.en.shortLabel',
		},
		{
			value: 'lv',
			label: 'globals.languages.lv.label',
			shortLabel: 'globals.languages.lv.shortLabel',
		},
	],
};

export default enums;
